
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import PlatformMarkerJungleLogMid from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogMid";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import MoverData from "../../../components/platformer/MoverData";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import PositionMarker from "../../editor/PositionMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import PlatformMarkerJungleLogKnot from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogKnot";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunk2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerJungleLogMid(scene, 454, 1);
    this.add(platformMarkerLogMid);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 179, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4323, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 601, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 287, 139);
    this.add(pole_long_float_png);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerJungleLog(scene, 1003, -131);
    this.add(platformLog_1);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 2716, -686);
    this.add(platformLog_3);

    // platformLog_4
    const platformLog_4 = new PlatformMarkerJungleLog(scene, 3756, -273);
    this.add(platformLog_4);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1445, 215);
    this.add(platformCabin);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerJungleLog(scene, 2029, -582);
    this.add(platformLog_5);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 1003, -125);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 1136, -250);
    this.add(positionMarker_1);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2038, -76);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1581, -430);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2031, -652);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2690, -762);
    this.add(gemMarker_3);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 2655, -537);
    this.add(crateMarker);

    // platformLog_6
    const platformLog_6 = new PlatformMarkerJungleLog(scene, 2058, -1);
    this.add(platformLog_6);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 1886, 142);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 2215, 142);
    this.add(pole_long_float_png_5);

    // platformLog_7
    const platformLog_7 = new PlatformMarkerJungleLog(scene, 2702, -3);
    this.add(platformLog_7);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 2530, 140);
    this.add(pole_long_float_png_6);

    // pole_long_float_png_7
    const pole_long_float_png_7 = new DecorationFloatingPoleLong(scene, 2859, 140);
    this.add(pole_long_float_png_7);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 995, 159);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 3462, -55);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3760, -58);
    this.add(gemMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2591, -89);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 2437, -454);
    this.add(gemMarker_11);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 2822, -87);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 546, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3759, -328);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 1461, 85);
    this.add(megaGemMarker_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2837, -454);
    this.add(megaGemMarker_2);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 2657, -395);
    this.add(platformMarkerLogLong_1);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 4043, 139);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 3757, 139);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 3466, 139);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 3155, 139);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 3607, 9);
    this.add(platformMarkerLogLong_3);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 984, 247);
    this.add(platformMarkerSubmergedBarrel);

    // platformMarkerLogKnot
    const platformMarkerLogKnot = new PlatformMarkerJungleLogKnot(scene, 1579, -363);
    this.add(platformMarkerLogKnot);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 307, -36);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1900, -43);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 3193, -22);
    this.add(checkpointMarker_2);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformLog_1 (components)
    const platformLog_1MoverData = new MoverData(platformLog_1);
    platformLog_1MoverData.startMarker = positionMarker;
    platformLog_1MoverData.endMarker = positionMarker_1;
    platformLog_1MoverData.startWait = 800;

    // crateMarker (components)
    const crateMarkerSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker);
    crateMarkerSimpleBreakableBlocker.allowedCharacter = "panda";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
